// auto-scale
export enum TimelineIconEnum {
  CHECKED = "CHECKED",
  UNCHECKED = "UNCHECKED",
  STAR = "STAR",
}
